<template>
  <div class="meta-service-box">
    <div class="meta-service-banner">
      <img src="@/assets/img/metaService/banner.jpg" alt="banner" />
      <div>
        <h2>元服务</h2>
        <p>
          元服务是华为HarmonyOS提供的一种面向未来的服务提供方式，是有独立入口、免安装、可为用户提供一个或多个服务的新型应用程序形态
        </p>
        <a-button class="btn-red" @click="add">免费咨询</a-button>
      </div>
    </div>
    <div class="meta-service-device">
      <div class="meta-service-device-info">
        <p><span>1+8+N设备</span>无缝流转，跨端迁移</p>
        <div>
          <div>
            <p>鸿蒙生态设备</p>
            <div>
              7 <span>亿</span>
              <img src="@/assets/img/metaService/icon1.png" alt="icon" />
            </div>
          </div>
          <div>
            <p>活跃用户增长</p>
            <div>11 <span>倍</span></div>
          </div>
        </div>
        <div>
          <div>
            <p>APP使用频次增长</p>
            <div>20 <span>倍</span></div>
          </div>
          <div>
            <p>单月用户增长</p>
            <div>4000+</div>
          </div>
        </div>
      </div>
      <div class="meta-service-device-video">
        <img
          src="@/assets/img/metaService/fbbtn.png"
          alt="播放"
          @click="handlePlay"
          v-if="!isPlay"
        />
        <video
          ref="videoRef"
          src="@/assets/img/metaService/sp1.mp4"
          loop
          muted
        ></video>
      </div>
    </div>
    <div class="meta-service-advantage">
      <p>服务优势</p>
      <span>为用户提供了更加统一、‌高效的应用使用体验</span>
      <div class="meta-service-advantage-list">
        <div v-for="(item, index) in advantageList" :key="index">
          <img :src="item.img" alt="icon" />
          <p>{{ item.title }}</p>
          <span>{{ item.desc }}</span>
        </div>
      </div>
    </div>
    <div class="meta-service-desc">
      <div>
        <p>元服务以万能卡片的形态，带来更便捷的体验</p>
        <span>实时信息始终在线，可大可小可交互</span>
        <div>
          <div class="meta-service-desc-type">
            <span :class="{ active: carouselIdex === 0 }" @click="goToSlide(0)"
              >卡片态</span
            >
            <span :class="{ active: carouselIdex === 1 }" @click="goToSlide(1)"
              >胶囊态</span
            >
            <span :class="{ active: carouselIdex === 2 }" @click="goToSlide(2)"
              >弦月窗</span
            >
          </div>
          <div class="custom-slick-arrow prev-icon">
            <a-icon type="left" class="arrow-icon" @click="goPrev" />
          </div>
          <div class="custom-slick-arrow next-icon">
            <a-icon type="right" class="arrow-icon" @click="goNext" />
          </div>
          <a-carousel ref="carousel" :dots="false">
            <div>
              <div class="meta-service-desc-item">
                <span>
                  <img src="@/assets/img/metaService/icon22.png" />
                </span>
                <div>
                  <p>
                    卡片外显 服务直达
                    <img src="@/assets/img/metaService/icon10.png" />
                  </p>
                  <span>以卡片形态呈现关键信息，一键直达服务页面</span>
                </div>
              </div>
            </div>
            <div>
              <div class="meta-service-desc-item">
                <span>
                  <img src="@/assets/img/metaService/icon24.png" />
                </span>
                <div>
                  <p>
                    双形态切换 实时掌握应用状态
                    <img src="@/assets/img/metaService/icon10.png" />
                  </p>
                  <span>实况窗胶囊态和卡片态切换，‌快速执行常用操作</span>
                </div>
              </div>
            </div>
            <div>
              <div class="meta-service-desc-item">
                <span>
                  <img src="@/assets/img/metaService/icon23.png" />
                </span>
                <div>
                  <p>
                    实时信息 抬腕即知
                    <img src="@/assets/img/metaService/icon10.png" />
                  </p>
                  <span>同步显示手机实况窗信息、‌提供临近提醒服务</span>
                </div>
              </div>
            </div>
          </a-carousel>
        </div>
      </div>
    </div>
    <div class="meta-service-compare">
      <p>功能对比</p>
      <span>灵活性、‌可组合性、‌跨设备兼容性以及性能优化对比</span>
      <div class="meta-service-compare-list">
        <div>
          <img src="@/assets/img/metaService/icon11.png" />
          <p>传统应用</p>
          <span>传统的软件开发模式,通常是在本地服务器上运行</span>
          <div>
            <p><img src="@/assets/img/metaService/icon14.png" />手动下载安装</p>
            <p><img src="@/assets/img/metaService/icon14.png" />包大小无限制</p>
            <p><img src="@/assets/img/metaService/icon14.png" />按需使用</p>
            <p>
              <img src="@/assets/img/metaService/icon14.png" />
              应用内或应用市场更新
            </p>
            <p>
              <img
                src="@/assets/img/metaService/icon14.png"
              />功能齐全，开发成本商，周期长
            </p>
          </div>
        </div>
        <div>
          <img src="@/assets/img/metaService/icon12.png" />
          <p>元服务</p>
          <span
            >有独立入口、免安装、可为用户提供一个或多个服务的新型应用程序形态</span
          >
          <div>
            <p><img src="@/assets/img/metaService/icon15.png" />免安装轻量化</p>
            <p>
              <img src="@/assets/img/metaService/icon15.png" />鸿蒙生态1+8+N
            </p>
            <p>
              <img
                src="@/assets/img/metaService/icon15.png"
              />小艺桌面，场景推荐
            </p>
            <p>
              <img src="@/assets/img/metaService/icon15.png" />
              桌面入口，一键直达
            </p>
            <p>
              <img src="@/assets/img/metaService/icon15.png" />多渠道高效触达
            </p>
            <p>
              <img src="@/assets/img/metaService/icon15.png" />自定义定制化内容
            </p>
          </div>
        </div>
        <div>
          <img src="@/assets/img/metaService/icon13.png" />
          <p>小程序</p>
          <span
            >独立的、功能完整的应用程序,可以在专门为它们设计的平台上运行</span
          >
          <div>
            <p><img src="@/assets/img/metaService/icon16.png" />免安装轻量化</p>
            <p>
              <img src="@/assets/img/metaService/icon16.png" />依赖单一APP生态
            </p>
            <p>
              <img
                src="@/assets/img/metaService/icon16.png"
              />获客难，依赖私域流量
            </p>
            <p>
              <img src="@/assets/img/metaService/icon16.png" />
              入口深，调用繁琐
            </p>
            <p>
              <img src="@/assets/img/metaService/icon16.png" />入口少，使用不便
            </p>
            <p>
              <img src="@/assets/img/metaService/icon16.png" />内容单一程式化
            </p>
          </div>
        </div>
      </div>
      <div class="meta-service-dev-process">
        <p>元服务开发流程</p>
        <div>
          <div>
            <img src="@/assets/img/metaService/1.png" />
            <p><img src="@/assets/img/metaService/icon17.png" />开发前</p>
          </div>
          <div>
            <img src="@/assets/img/metaService/2.png" />
            <p><img src="@/assets/img/metaService/icon18.png" />开发中</p>
          </div>
          <div>
            <img src="@/assets/img/metaService/3.png" />
            <p><img src="@/assets/img/metaService/icon19.png" />打包</p>
          </div>
          <div>
            <img src="@/assets/img/metaService/4.png" />
            <p><img src="@/assets/img/metaService/icon20.png" />测试</p>
          </div>
          <div>
            <img src="@/assets/img/metaService/5.png" />
            <p><img src="@/assets/img/metaService/icon21.png" />上架</p>
          </div>
        </div>
      </div>
    </div>
    <div class="meta-service-case">
      <div>
        <p>客户案例</p>
        <span>最佳实践，激发不同类型用户</span>
        <a-carousel autoplay>
          <div>
            <div class="meta-service-case-list">
              <span>
                <img src="@/assets/img/metaService/ad1.jpg" />
              </span>
              <div>
                <h3>喜马拉雅元服务</h3>
                <p>
                  <span>轻量化</span>
                  <span>即走即用</span>
                </p>
                <span
                  >喜马拉雅元服务是喜马拉雅平台提供的一种轻量化、即用即走的应用形态，它基于HarmonyOS等先进的操作系统，无需安装即可使用的应用形态，用户可以通过点击卡片、碰一碰、扫一扫等方式直接触发，享受“即用即走”的流畅体验。喜马拉雅元服务，‌可以一键听书/听新闻，‌活跃用户增长了11倍。‌</span
                >
                <div>
                  <div>
                    <p>20 <span>倍</span></p>
                    <span>活跃用户增长</span>
                  </div>
                  <div>
                    <p>3 <span>倍</span></p>
                    <span>相比APP使用频次增长</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="meta-service-case-list">
              <span>
                <img src="@/assets/img/metaService/ad1.jpg" />
              </span>
              <div>
                <h3>喜马拉雅元服务</h3>
                <p>
                  <span>轻量化</span>
                  <span>即走即用</span>
                </p>
                <span
                  >喜马拉雅元服务是喜马拉雅平台提供的一种轻量化、即用即走的应用形态，它基于HarmonyOS等先进的操作系统，无需安装即可使用的应用形态，用户可以通过点击卡片、碰一碰、扫一扫等方式直接触发，享受“即用即走”的流畅体验。喜马拉雅元服务，‌可以一键听书/听新闻，‌活跃用户增长了11倍。‌</span
                >
                <div>
                  <div>
                    <p>20 <span>倍</span></p>
                    <span>活跃用户增长</span>
                  </div>
                  <div>
                    <p>3 <span>倍</span></p>
                    <span>相比APP使用频次增长</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="meta-service-case-list">
              <span>
                <img src="@/assets/img/metaService/ad1.jpg" />
              </span>
              <div>
                <h3>喜马拉雅元服务</h3>
                <p>
                  <span>轻量化</span>
                  <span>即走即用</span>
                </p>
                <span
                  >喜马拉雅元服务是喜马拉雅平台提供的一种轻量化、即用即走的应用形态，它基于HarmonyOS等先进的操作系统，无需安装即可使用的应用形态，用户可以通过点击卡片、碰一碰、扫一扫等方式直接触发，享受“即用即走”的流畅体验。喜马拉雅元服务，‌可以一键听书/听新闻，‌活跃用户增长了11倍。‌</span
                >
                <div>
                  <div>
                    <p>20 <span>倍</span></p>
                    <span>活跃用户增长</span>
                  </div>
                  <div>
                    <p>3 <span>倍</span></p>
                    <span>相比APP使用频次增长</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
    <AddService ref="addServiceRef" v-if="isLogin" />
  </div>
</template>

<script>
import AddService from "./components/addService.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AddService,
  },
  computed: {
    ...mapGetters(["userInfo", "isLogin"]),
  },
  data() {
    return {
      advantageList: [
        {
          img: require("@/assets/img/metaService/icon2.png"),
          title: "轻量化服务",
          desc: "用户无需安装即可使用，通过点击卡片、碰一碰等方式直接触发，享受“即用即走”的流畅体验",
        },
        {
          img: require("@/assets/img/metaService/icon3.png"),
          title: "即用即走",
          desc: "用户可以随时根据需要调用元服务，使用完毕后无需手动关闭或卸载，系统会自动管理",
        },
        {
          img: require("@/assets/img/metaService/icon4.png"),
          title: "多终端支持",
          desc: "不仅限于手机，还可以在平板、电脑、智慧屏等多种终端上运行，实现跨设备的无缝流转和迁移",
        },
        {
          img: require("@/assets/img/metaService/icon5.png"),
          title: "个性化服务",
          desc: "可以根据用户的使用习惯和场景需求，提供个性化的服务推荐和分发",
        },
        {
          img: require("@/assets/img/metaService/icon6.png"),
          title: "流畅体验",
          desc: "用户在打开元服务时能够感受到丝滑流畅、干净无广告的体验",
        },
        {
          img: require("@/assets/img/metaService/icon7.png"),
          title: "适配成本低",
          desc: "鸿蒙元服务的代码可以100%复用到原生应用开发，并支持“一多开发，多端部署”的高效策略",
        },
      ],
      isPlay: false,
      carouselIdex: 0,
    };
  },
  methods: {
    add() {
      if (!this.isLogin) {
        this.$message.warning("您还未登录");
        return;
      }
      this.$refs.addServiceRef.open();
    },
    handlePlay() {
      this.$refs.videoRef.play();
      this.isPlay = true;
    },
    goToSlide(slideIndex) {
      this.carouselIdex = slideIndex;
      this.$refs.carousel.goTo(slideIndex);
    },
    goPrev() {
      let idx = this.carouselIdex - 1;
      if (idx < 0) {
        idx = 2;
      }
      this.carouselIdex = idx;
      this.$refs.carousel.prev();
    },
    goNext() {
      let idx = this.carouselIdex + 1;
      if (idx > 2) {
        idx = 0;
      }
      this.carouselIdex = idx;
      this.$refs.carousel.next();
    },
  },
};
</script>

<style scoped lang="scss">
.meta-service-box {
  background: #fff;
}
.meta-service-banner {
  position: relative;
  height: 480px;
  > img {
    width: 100%;
    height: 100%;
    display: block;
  }
  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1280px;
    > h2 {
      font-size: 40px;
      color: #262626;
      line-height: 56px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    > p {
      width: 640px;
      font-size: 24px;
      color: #666666;
      line-height: 32px;
      margin-bottom: 40px;
      text-align: justify;
    }
  }
}
.meta-service-device {
  width: 1280px;
  margin: 0 auto;
  padding: 64px 0;
  display: flex;
  justify-content: space-between;
  .meta-service-device-info {
    > p {
      font-size: 32px;
      color: #000;
      line-height: 45px;
      font-weight: bold;
      > span {
        color: #ea0b06;
      }
    }
    > div {
      margin-top: 48px;
      display: flex;
      > div {
        width: 280px;
        > p {
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          margin-bottom: 6px;
        }
        > div {
          display: flex;
          align-items: flex-end;
          font-weight: bold;
          font-size: 48px;
          color: #262626;
          line-height: 66px;
          > span {
            font-weight: 400;
            font-size: 16px;
            color: #262626;
            line-height: 42px;
            margin-left: 8px;
          }
          > img {
            margin-left: 12px;
            padding-bottom: 14px;
          }
        }
      }
    }
  }
  .meta-service-device-video {
    border: 1px solid #e5e5e5;
    position: relative;
    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      cursor: pointer;
      z-index: 2;
    }
    > video {
      display: block;
      width: 580px;
      height: 326px;
    }
  }
}
.meta-service-advantage {
  width: 1280px;
  margin: 0 auto;
  padding: 64px 0;
  > p {
    font-weight: bold;
    font-size: 32px;
    color: #000000;
    line-height: 45px;
    margin-bottom: 16px;
    text-align: center;
  }
  > span {
    display: block;
    font-size: 18px;
    color: #666666;
    line-height: 28px;
    margin-bottom: 23px;
    text-align: center;
  }
  .meta-service-advantage-list {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 410px;
      margin: 25px 25px 0 0;
      border: 1px solid #e3e8ee;
      padding: 40px 32px;
      text-align: center;
      transition: all 0.3s ease;
      cursor: pointer;
      > img {
        display: block;
        width: 80px;
        height: 80px;
        margin: 0 auto 24px;
      }
      > p {
        font-size: 18px;
        color: #262626;
        line-height: 32px;
        text-align: center;
        margin-bottom: 24px;
      }
      > span {
        display: block;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #e3e8ee;
      }
    }
  }
}
.meta-service-desc {
  padding: 64px 0 80px;
  background: url(../../../assets/img/metaService/bg3.jpg) no-repeat;
  background-size: 100% 100%;
  > div {
    width: 1280px;
    margin: 0 auto;
    > p {
      font-weight: bold;
      font-size: 32px;
      color: #000000;
      line-height: 45px;
      margin-bottom: 16px;
      text-align: center;
    }
    > span {
      display: block;
      font-size: 18px;
      color: #666666;
      line-height: 28px;
      margin-bottom: 48px;
      text-align: center;
    }
    > div {
      position: relative;
      .custom-slick-arrow {
        position: absolute;
        top: 190px;
        z-index: 2;
        cursor: pointer;
        width: 32px;
        height: 32px;
      }
      .prev-icon {
        left: 16px;
      }
      .next-icon {
        right: 8px;
      }
    }
    .meta-service-desc-type {
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 56px;
      > span {
        padding: 0 63px;
        border-bottom: 2px solid transparent;
        height: 50px;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 25px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-right: 48px;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border-color: #ea0b06;
        }
        &.active {
          border-color: #ea0b06;
        }
      }
    }
  }
}
.meta-service-desc-item {
  display: flex;
  padding: 0 167px 0 132px;
  > span {
    width: 548px;
    height: 433px;
    margin-right: 24px;
    > img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  > div {
    padding-top: 100px;
    flex: 1;
    > p {
      font-weight: bold;
      font-size: 24px;
      color: #262626;
      line-height: 32px;
      margin-bottom: 26px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
    > span {
      display: block;
      font-size: 16px;
      color: #666666;
      line-height: 22px;
    }
  }
}
.arrow-icon {
  font-size: 32px;
  color: #262626;
  &:hover {
    color: #ea0b06;
  }
}
.meta-service-compare {
  width: 1280px;
  padding: 64px 0;
  margin: 0 auto;
  > p {
    font-weight: bold;
    font-size: 32px;
    color: #000000;
    line-height: 45px;
    margin-bottom: 16px;
    text-align: center;
  }
  > span {
    display: block;
    font-size: 18px;
    color: #666666;
    line-height: 28px;
    margin-bottom: 48px;
    text-align: center;
  }
  .meta-service-compare-list {
    display: flex;
    justify-content: space-between;
    > div {
      width: 400px;
      height: 619px;
      padding: 40px;
      background: #f6f6fb url(../../../assets/img/metaService/bg4.png) right
        bottom no-repeat;
      > img {
        display: block;
        margin: 0 auto 32px;
      }
      > p {
        font-weight: bold;
        font-size: 24px;
        color: #262626;
        line-height: 32px;
        margin-bottom: 24px;
        text-align: center;
      }
      > span {
        font-size: 16px;
        color: #666666;
        line-height: 22px;
        display: block;
        padding-bottom: 24px;
        margin-bottom: 40px;
      }
      &:nth-child(1) {
        > span {
          border-bottom: 1px solid #ffd8ba;
        }
      }
      &:nth-child(2) {
        > span {
          border-bottom: 1px solid #e5e5e5;
        }
      }
      &:nth-child(3) {
        > span {
          border-bottom: 1px solid #8affb4;
        }
      }
      > div {
        > p {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #262626;
          line-height: 22px;
          margin-bottom: 24px;
          &:last-child {
            margin-bottom: 0;
          }
          > img {
            margin-right: 8px;
          }
        }
      }
    }
  }
}
.meta-service-dev-process {
  margin-top: 56px;
  height: 240px;
  background: url(../../../assets/img/metaService/bg1.jpg) no-repeat;
  background-size: 100% 100%;
  padding: 32px 96px 0;
  > p {
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    line-height: 33px;
    margin-bottom: 59px;
    text-align: center;
  }
  > div {
    display: flex;
    justify-content: space-between;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
      left: 22px;
      right: 73px;
      z-index: 2;
      bottom: -30px;
    }
    > div {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 12px;
        height: 12px;
        border: 2px solid #848484;
        border-radius: 50%;
        background: #ea0b06;
        bottom: -35px;
        left: 12px;
        z-index: 3;
      }
      > img {
        position: absolute;
        bottom: 12px;
        left: -48px;
      }
      > p {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        line-height: 24px;
        > img {
          margin-right: 16px;
        }
      }
    }
  }
}
.meta-service-case {
  padding: 64px 0 115px;
  background: url(../../../assets/img/metaService/bg2.jpg) no-repeat;
  background-size: 100% 100%;
  > div {
    width: 1280px;
    margin: 0 auto;
    > p {
      font-weight: bold;
      font-size: 32px;
      color: #000000;
      line-height: 45px;
      margin-bottom: 16px;
      text-align: center;
    }
    > span {
      display: block;
      font-size: 18px;
      color: #666666;
      line-height: 28px;
      margin-bottom: 48px;
      text-align: center;
    }
    .meta-service-case-list {
      background: #fff;
      display: flex;
      > span {
        width: 554px;
        height: 432px;
        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      > div {
        flex: 1;
        padding: 56px 64px;
        > h3 {
          font-weight: bold;
          font-size: 28px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 40px;
          margin-bottom: 24px;
        }
        > p {
          display: flex;
          margin-bottom: 24px;
          > span {
            height: 20px;
            border-radius: 2px;
            border: 1px solid #d1d8e4;
            padding: 0 4px;
            font-size: 12px;
            color: #62697d;
            line-height: 18px;
            margin-right: 16px;
          }
        }
        > span {
          font-size: 16px;
          color: rgba(102, 102, 102, 0.85);
          line-height: 22px;
          display: block;
          margin-bottom: 36px;
          text-align: justify;
        }
        > div {
          display: flex;
          > div {
            margin-right: 60px;
            > p {
              font-weight: bold;
              font-size: 42px;
              color: #262626;
              line-height: 66px;
              display: flex;
              align-items: flex-end;
              > span {
                font-size: 14px;
                color: #262626;
                line-height: 48px;
                margin-left: 6px;
                font-weight: 400;
              }
            }
            > span {
              display: block;
              font-size: 14px;
              color: #999999;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
::v-deep {
  .ant-carousel .slick-dots-bottom {
    bottom: -48px;
  }
  .ant-carousel .slick-dots li button {
    background: #d1d5d8;
    opacity: 1;
  }
  .ant-carousel .slick-dots li.slick-active button {
    background: #ea0b06;
  }
}
</style>
